import loadable from "@loadable/component";

interface IAsyncComponent {
    isModule?: boolean;
    path: string;
}

const AsyncComponent = ({ path, isModule = false, ...props }: IAsyncComponent) => {
    const Component = loadable(() => isModule ? import(`modules/${[path]}`) : import(`app/${[path]}`));
    return <Component {...props} />;
};

export default AsyncComponent;
